 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		8: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		8: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"5525b8a50b7acc3d4372d33c220d4cac2212e2b4","2":"3a488ff6e94e8ef829bb490290e2e6168a3e199c","3":"468f25fd2273892736894f0a74ed903276caf6c5","4":"ff1447d7b16b7f678fd24d604bf9dd518c0dd57f","5":"0084ab9fa43369b5fdf9f138e0050859ccaabe24","6":"184892ca1d61440366efd99954c69dc86dd1b4ec","7":"be5fdd42491a46a97ed957d11018069026c3eab4","10":"component---src-pages-404-js","11":"component---src-pages-about-us-js","12":"component---src-pages-aim-box-js","13":"component---src-pages-ask-an-analyst-js","14":"component---src-pages-ask-for-discount-js","15":"component---src-pages-b-2-b-b-2-c-consulting-js","16":"component---src-pages-blog-js","17":"component---src-pages-career-js","18":"component---src-pages-comtex-pressrelease-js","19":"component---src-pages-consulting-solutions-js","20":"component---src-pages-contact-us-js","21":"component---src-pages-data-analytics-js","22":"component---src-pages-data-market-monitoring-js","23":"component---src-pages-disclaimer-js","24":"component---src-pages-home-js","25":"component---src-pages-index-js","26":"component---src-pages-industry-js","27":"component---src-pages-it-solutions-js","28":"component---src-pages-market-report-research-latest-published-reports-js","29":"component---src-pages-market-research-reports-js","30":"component---src-pages-news-and-resources-js","31":"component---src-pages-press-js","32":"component---src-pages-press-release-js","33":"component---src-pages-privacy-policy-js","34":"component---src-pages-published-research-connected-car-security-market-js","35":"component---src-pages-published-research-sheer-quadrant-js","36":"component---src-pages-regions-js","37":"component---src-pages-report-js","38":"component---src-pages-request-brochure-js","39":"component---src-pages-request-sample-js","40":"component---src-pages-search-results-js","41":"component---src-pages-seo-and-translation-services-js","42":"component---src-pages-solutions-js","43":"component---src-pages-submit-query-js","44":"component---src-pages-terms-of-use-js","45":"component---src-templates-ask-an-analyst-template-js","46":"component---src-templates-ask-for-discount-template-js","47":"component---src-templates-blog-template-js","48":"component---src-templates-category-report-template-js","49":"component---src-templates-category-sector-report-template-js","50":"component---src-templates-news-template-js","51":"component---src-templates-press-template-js","52":"component---src-templates-region-report-template-js","53":"component---src-templates-region-sector-report-template-js","54":"component---src-templates-report-template-js","55":"component---src-templates-request-brochure-template-js","56":"component---src-templates-request-sample-template-js"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"87281e47d978ccc25a05","2":"81e8bb451019f37e96c6","3":"c6b45015c9ffc9be5f5b","4":"9d196ecfdcad53b99b70","5":"c244ad1c2b3051ca5dbc","6":"370a86e7837f07d57995","7":"ed3cee814537bb9e63be","10":"3113a3ca526470299b34","11":"3050f9b8cfc709370dfa","12":"80aeb5312333cd3a5894","13":"33481e933ba7c873c8b6","14":"644af1047e6d01db96bb","15":"857490ac9eac6ff995fc","16":"01a5d0075a638006a4c6","17":"10ca2d26fae99007bd15","18":"8fc90695a4f9b0631591","19":"94db7ca3c32c66ae3740","20":"98312c675208ed6e3de7","21":"8439c9c5f1b029c5233a","22":"ec8d862a1b48d3ef45ba","23":"57cc2da5a26a0ae467a4","24":"b7e40b3df041cc5905ae","25":"a0aafb4f8d237b0dfa8f","26":"b8986941675aaa6a7e3e","27":"3f7ca1d186c056f202dc","28":"84a7faec0e6fff952f45","29":"ffe913d723928b958d28","30":"7b8e8ad35248acebc26c","31":"5409aa25524390b0d10b","32":"2f7571cd3515e9c98ad8","33":"2b5c46e4c72cee0ba86b","34":"d7d0899f5d44eccb8447","35":"bac2b69d2f44d5c4eddc","36":"0e12fa251152fc7e2a84","37":"61653ed0458431bc1585","38":"208eced91c88c40c5577","39":"e713e3bad215a4194969","40":"e7f3c4389f2b37dfb411","41":"fceee3c1bbb90ea72b10","42":"b08b01c38e97a2004044","43":"82f471f5a2fb8cebb015","44":"b2d0a73f64b30dac455e","45":"100be0be6f8f4fb3302c","46":"c8271fee5b10e6ebb236","47":"74bffc59d5e6f4a8c9cf","48":"649e938987ee9539cff5","49":"17123516cbff7b657c12","50":"491bbbc8091e77be6201","51":"d4a092a327f67d05b58b","52":"f07ed7babb846df21e5b","53":"b61572075941119a546e","54":"89815e1e66d58b183d1c","55":"804bf9310369ec43af84","56":"16f104b187ac586c86c3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"5525b8a50b7acc3d4372d33c220d4cac2212e2b4","2":"3a488ff6e94e8ef829bb490290e2e6168a3e199c","3":"468f25fd2273892736894f0a74ed903276caf6c5","4":"ff1447d7b16b7f678fd24d604bf9dd518c0dd57f","5":"0084ab9fa43369b5fdf9f138e0050859ccaabe24","6":"184892ca1d61440366efd99954c69dc86dd1b4ec","7":"be5fdd42491a46a97ed957d11018069026c3eab4","10":"component---src-pages-404-js","11":"component---src-pages-about-us-js","12":"component---src-pages-aim-box-js","13":"component---src-pages-ask-an-analyst-js","14":"component---src-pages-ask-for-discount-js","15":"component---src-pages-b-2-b-b-2-c-consulting-js","16":"component---src-pages-blog-js","17":"component---src-pages-career-js","18":"component---src-pages-comtex-pressrelease-js","19":"component---src-pages-consulting-solutions-js","20":"component---src-pages-contact-us-js","21":"component---src-pages-data-analytics-js","22":"component---src-pages-data-market-monitoring-js","23":"component---src-pages-disclaimer-js","24":"component---src-pages-home-js","25":"component---src-pages-index-js","26":"component---src-pages-industry-js","27":"component---src-pages-it-solutions-js","28":"component---src-pages-market-report-research-latest-published-reports-js","29":"component---src-pages-market-research-reports-js","30":"component---src-pages-news-and-resources-js","31":"component---src-pages-press-js","32":"component---src-pages-press-release-js","33":"component---src-pages-privacy-policy-js","34":"component---src-pages-published-research-connected-car-security-market-js","35":"component---src-pages-published-research-sheer-quadrant-js","36":"component---src-pages-regions-js","37":"component---src-pages-report-js","38":"component---src-pages-request-brochure-js","39":"component---src-pages-request-sample-js","40":"component---src-pages-search-results-js","41":"component---src-pages-seo-and-translation-services-js","42":"component---src-pages-solutions-js","43":"component---src-pages-submit-query-js","44":"component---src-pages-terms-of-use-js","45":"component---src-templates-ask-an-analyst-template-js","46":"component---src-templates-ask-for-discount-template-js","47":"component---src-templates-blog-template-js","48":"component---src-templates-category-report-template-js","49":"component---src-templates-category-sector-report-template-js","50":"component---src-templates-news-template-js","51":"component---src-templates-press-template-js","52":"component---src-templates-region-report-template-js","53":"component---src-templates-region-sector-report-template-js","54":"component---src-templates-report-template-js","55":"component---src-templates-request-brochure-template-js","56":"component---src-templates-request-sample-template-js"}[chunkId]||chunkId) + "." + {"0":"e7c14de39459b1413fc2","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
